import React from 'react';

// Elo de corrente partido — usado no item "Distrato" (encerrar vínculo).
// Traço em currentColor para acompanhar a cor do texto onde for usado.
export default function IcVinculo() {
  return (
    <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" strokeWidth="1.5" strokeLinecap="round">
        <path d="M9.9,4.7 L11.9,4.7 A3.3,3.3 0 0 1 11.9,11.3 L9.9,11.3" stroke="currentColor" />
        <path d="M6.1,11.3 L4.1,11.3 A3.3,3.3 0 0 1 4.1,4.7 L6.1,4.7" stroke="currentColor" />
        <path d="M8,2.1 L8,3.5" stroke="currentColor" />
        <path d="M8,12.5 L8,13.9" stroke="currentColor" />
      </g>
    </svg>
  );
}
